// ajax for SVG sprite
window.addEventListener('load', function(event) {
    var svgAjax = new XMLHttpRequest();
    svgAjax.open("GET", base_dir + "/dist/svg/sprite.svg", true);
    svgAjax.send();
    svgAjax.onload = function(e) {
        var div = document.createElement("div");
        div.innerHTML = svgAjax.responseText;
        div.setAttribute("id", "sprites");
        div.style.display = "none";
        document.body.insertBefore(div, document.body.childNodes[0]);
    }
});

jQuery('document').ready(function($) {
    var url = ajax_url;
    var pageURL = window.location.pathname.split("/");
    var lastSegment = pageURL.pop() || pageURL.pop();

    var messages = $(".messages div").length;

    if (messages > 0) {
        setTimeout(function(){ 
            $(".messages div").addClass("fade-out");
        }, 500);

        setTimeout(function(){ 
            $(".messages div").remove();
        }, 1500);
    }

    // Add ajax
    $(".favorite--add").on('click', function() {
        var favoriteID = $(this).attr('id');

        if (favoriteID) {
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    action: 'add_favorite',
                    favoriteID: favoriteID
                }
            }).then(function(data) {
                console.log(`${favoriteID} was stored to database!`);
                $(`#${favoriteID}`)
                    .removeClass("favorite--add")
                    .addClass("favorite--remove")
                    .attr('title', 'Remove from favorites');

                if (lastSegment === "total-videos-page") {
                   $('<div class="favorites-message">Video has been added to favorites!</div>').insertBefore('.pagination');
                } else { 
                    $('<div class="favorites-message">Video has been added to favorites!</div>').insertAfter('.video-category-area');
                }
                
                $(`svg#${favoriteID}`).css("color","red");

                setTimeout(function(){ 
                    $(".favorites-message").addClass("fade-out");
                }, 500);

                setTimeout(function(){ 
                    $(".favorites-message").remove();
                }, 1500);
            }).fail(function(data) {
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            });
        } else {
            console.log("No favorite icon was pressed.")
        }
        return false;
    });

    // Remove ajax
    $(".favorite--remove").on('click', function() {
        var favoriteID = $(this).attr('id');
        var favoritesPage = $(location).attr('search');

        if (favoriteID) {
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    action: 'remove_favorite',
                    favoriteID: favoriteID
                }
            }).then(function(data) {
                console.log(`${favoriteID} was removed from database!`);
                $(`#${favoriteID}`)
                    .removeClass("favorite--remove")
                    .addClass("favorite--add")
                    .attr('title', 'Add to favorites');

                if (favoritesPage) {
                    $(`#${favoriteID}`).parents(".video-box").remove();
                    var remainingVideos = $('.items').children().length;

                    if (remainingVideos > 0) {
                        $("#clear-favorites-section")
                            .append('<div class="favorites-message">Video has been removed from favorites!</div>');

                        setTimeout(function(){ 
                            $(".favorites-message").addClass("fade-out");
                        }, 500);
                    }

                    if (remainingVideos === 0) {
                        $("#clear-favorites-section")
                            .append('<div class="favorites-message">Videos were cleared from favorites!</div>');

                        setTimeout(function(){ 
                            $(".favorites-message").addClass("fade-out");
                        }, 500);
                    }

                    setTimeout(function(){ 
                        $(".favorites-message").remove();
                        
                        if (remainingVideos === 0) {
                            $(".video-listing")
                                .empty()
                                .append('<div class="no-videos no-videos--white-theme"><p>No favorite videos yet!</p></div>');
                        }
                    }, 1500);
                } else if (lastSegment === "total-videos-page") {
                   $('<div class="favorites-message">Video has been removed from favorites!</div>').insertBefore('.pagination');
                } else { 
                    $('<div class="favorites-message">Video has been removed from favorites!</div>').insertAfter('.video-category-area');
                }

                $(`svg#${favoriteID}`).css("color","#FFF");

                setTimeout(function(){ 
                    $(".favorites-message").addClass("fade-out");
                }, 500);

                setTimeout(function(){ 
                    $(".favorites-message").remove();
                }, 1500);
            }).fail(function(data) {
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            });
        } else {
            console.log("No favorite icon was pressed.")
        }
        return false;
    });

    // Delete all ajax
    $(".clear-favorites").on('click', function() {
        var total_videos = $(".clear-favorites").attr("total_videos");
        
        if (total_videos > 0) {
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    action: 'clear_favorites',
                    total_videos: total_videos
                }
            }).then(function(data) {
                $(".clear-favorites").css("display","none");
                $("#clear-favorites-section")
                    .append('<div class="favorites-message">Videos were cleared from favorites!</div>');
                
                setTimeout(function(){ 
                    $(".favorites-message").addClass("fade-out");
                }, 500);

                setTimeout(function(){ 
                    $(".favorites-message").addClass('hidden');
                    $(".video-listing")
                        .empty()
	                    .append('<div class="no-videos no-videos--white-theme"><p>No favorite videos yet!</p></div>');
                }, 1500);
                console.log('Favorite videos have been deleted from database!');
            }).fail(function(data) {
                $(".favorites-message").html("Something went wrong..").addClass("fade-out");
                setTimeout(function(){ 
                    $(".favorites-message").addClass('hidden')
                }, 1500);
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            });
        }
    });

    // Give ID to admin ajax
    $("#calisthenics_programs").change(function (event) {
        var uploadeeID = $(this).val();
        var pdf = $("input[name='hasUserPDF'");

        if (uploadeeID) {
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    action: 'uploadee_id',
                    uploadeeID: uploadeeID
                }
            }).then(function(data) {
                $("input[name='userId'").val(uploadeeID);
                $("#week_day_section").css("display", "flex");
                var obj = JSON.parse(data);
                pdf.val(obj.hasUserPDF);
                
                if (pdf.val() === "true") {
                    $("input[name='remove'").removeClass("hidden");
                } else {
                    $("input[name='remove'").addClass("hidden");
                }
                console.log(`Uploadee with ID: ${uploadeeID} was given to admin panel!`);
            }).fail(function(data) {
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            });
        } else {
            console.log("No uploadee ID was selected.")
        }
        return false;
    });

    // Remove specific's user pdf from database
    // $("input[name='remove'").on("click", function() {
    //     event.preventDefault();
    //     var uploadeeID = $("input[name='userId'").val();

    //     if (uploadeeID.length > 0) {
    //         $.ajax({
    //             url: url,
    //             type: 'POST',
    //             data: {
    //                 action: 'pdf_removal',
    //                 uploadeeID: uploadeeID
    //             }
    //         }).then(function(data) {
    //             console.log(`Uploadee with ID: ${uploadeeID} was given to handle_pdf_removal() function`);
    //             $(".messages")
    //                 .empty()
	//                 .append('<div class="success-msg">PDF was removed successfully!</div>');

    //             setTimeout(function(){ 
    //                 $(".messages div").addClass("fade-out");
    //             }, 500);

    //             setTimeout(function(){ 
    //                 $(".messages div").remove();
    //                 $("input[name='remove'").addClass("hidden");
    //             }, 1500);

    //         }).fail(function(data) {
    //             console.log(data.responseText);
    //             console.log('Request failed: ' + data.statusText);
    //         });
    //     } else {
    //         console.log("No uploadee ID was selected.")
    //     }
    //     return false;
    // });

    // Give days to admin ajax
    $("#days_per_week").change(function (event) {
        var daysPerWeek = $(this).val();
        var uploadeeID = $("input[name='userId']").val();
        var counter;

        if (daysPerWeek) {
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    action: 'days_per_week',
                    daysPerWeek: daysPerWeek,
                    uploadeeID: uploadeeID
                }
            }).then(function(data) {
                $("input[name='daysPerWeek'").val(daysPerWeek);
                $("#week_day_section").css("display", "flex");
            
                console.log(`Uploadee with ID: ${uploadeeID} will have ${daysPerWeek} trainings per week!`);
            }).fail(function(data) {
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            });
        } else {
            console.log("No date was selected.")
        }
        return false;
    });

    // Give week to admin ajax
    $("#choose_week").change(function (event) {
        var week = $(this).val();
        var uploadeeID = $("input[name='userId']").val();

        if (week) {
            $("#current_day_section").css("visibility", "visible");
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    action: 'choose_week',
                    week: week,
                    uploadeeID: uploadeeID
                }
            }).then(function(data) {
                $("input[name='week']").val(week);
                console.log(`Now passing data for week: ${week}!`);
            }).fail(function(data) {
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            });
        } else {
            console.log("No week was selected.")
        }
        return false;
    });

    // Give day (dependent to week) to admin ajax
    $("#current_day").change(function (event) {
        var curr_day = $(this).val();
        var uploadeeID = $("input[name='userId']").val();
        var week = $("input[name='week']").val();

        if (curr_day) {
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    action: 'current_day',
                    curr_day: curr_day,
                    uploadeeID: uploadeeID,
                    week: week
                }
            }).then(function(data) {
                $("input[name='currentDay']").val(curr_day);
                $("#exercise_per_day_section").css("display", "flex");
                console.log(`Now passing data for day: ${curr_day}!`);
            }).fail(function(data) {
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            });
        } else {
            console.log("No day was selected.")
        }
        return false;
    });

    // Give exercise per day to admin ajax
    $("#exercise_per_day").change(function (event) {
        var exercisesPerDay = $(this).val();
        var uploadeeID = $("input[name='userId']").val();
        var week = $("input[name='week']").val();
        var curr_day = $("input[name='currentDay']").val();
        var counter;

        if (exercisesPerDay) {
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    action: 'exercise_per_day',
                    curr_day: curr_day,
                    uploadeeID: uploadeeID,
                    week: week,
                    exercisesPerDay: exercisesPerDay
                }
            }).then(function(data) {
                $("input[name='exercisesPerDay'").val(exercisesPerDay);
                $("#program_fields").css("display", "block");
                console.log(`Now passing ${exercisesPerDay} exercises for current day!`);

                for (counter = 1; counter <= exercisesPerDay; counter++) {
                    $("#exercises_section form")
                        .append(`
                            <div>
                                <label class="appended-fields" for='name_${counter}'>Name of exercise: ${counter}</label>
                                <input class="appended-fields" type="text" name="name_${counter}">
                                <label class="appended-fields" for="url_${counter}">URL of exercise: ${counter}</label>
                                <input class="appended-fields" type="text" name="url_${counter}">
                                <input type="hidden" name="exercise_${counter}" value="${counter}">
                            </div>
                        `)

                //     $("#exercises_section")
                //         .append(`
                //             <label class="appended-fields" for='exerc_name_${counter}'>Name of exercise: ${counter}</label>
                //             <input class="appended-fields" type="text" name="exerc_name_${counter}"><div id="exerc_name_${counter}" class="save-btn">Save</div><br>
                //             <label class="appended-fields" for="exerc_url_${counter}">URL of exercise: ${counter}</label>
                //             <input class="appended-fields" type="text" name="exerc_url_${counter}"><div id="exerc_url_${counter}" class="save-btn">Save</div><br>
                //         `)
                    if (counter == exercisesPerDay) {
                        $("#exercises_section form")
                            .append(`<input id="send-data" class="save-btn" type="submit" value="Submit">`);
                    }
                }

            }).fail(function(data) {
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            });
        } else {
            console.log("No day was selected.")
        }
        return false;
    });

    // $(document).on('click', '[id^=exerc_]', function(event) {
    //     var saving = this.id;
    //     var inputData = $(`input[name=${saving}]`).val();
    //     var uploadeeID = $("input[name='userId']").val();
    //     var week = $("input[name='week']").val();
    //     var curr_day = $("input[name='currentDay']").val();
    //     var exercisesPerDay = $("input[name='exercisesPerDay'").val();

    //     console.log("inputData: ", inputData)

    //     if (inputData.length > 0) {
    //         $.ajax({
    //             url: ajax_url,
    //             type: 'POST',
    //             data: {
    //                 action: 'data_for_db',
    //                 curr_day: curr_day,
    //                 uploadeeID: uploadeeID,
    //                 week: week,
    //                 exercisesPerDay: exercisesPerDay,
    //                 inputData: inputData,
    //                 meta_for_query: saving
    //             }
    //         }).then(function(data) {
    //             console.log(`Data: ${inputData} is being transferred to DB!`);
    //         }).fail(function(data) {
    //             console.log(data.responseText);
    //             console.log('Request failed: ' + data.statusText);
    //         });
    //     } else {
    //         console.log("No exercise or URL was given.")
    //     }
    //     return false;
    // });

    $(document).on('submit', '#exercise-data', function(event) {
        event.preventDefault();

        var request;
        var uploadeeID = $("input[name='userId']").val();
        var week = $("input[name='week']").val();
        var curr_day = $("input[name='currentDay']").val();
        var exercisesPerDay = $("input[name='exercisesPerDay'").val();

        // Abort any pending request
        if (request) {
            request.abort();
        }
        
        var $form = $(this);
        var $inputs = $form.find("input, select, button, textarea");
        var inputData = $form.serialize();
        console.log(inputData);

        $inputs.prop("disabled", true);

        if (inputData.length > 0) {
            $.ajax({
                url: ajax_url,
                type: 'POST',
                data: {
                    action: 'data_for_db',
                    curr_day,
                    uploadeeID,
                    week,
                    exercisesPerDay,
                    inputData                    
                }
            }).then(function(data) {
                console.log(`Data: ${inputData} is being transferred to DB!`);
            }).fail(function(data) {
                console.log(data.responseText);
                console.log('Request failed: ' + data.statusText);
            }).always(function() {
                $inputs.prop("disabled", false);
            });
        } else {
            console.log("No exercise or URL was given.")
        }
        //return false;
    });
});